import fetch from '@/util/http'
import common from './core'
import activity from './activity'
import category from './category'
import record from './record'
import coupon from './coupon'
import comment from './comment'
import vip from './vip'
import award from './award'

export default {
  ...activity,
  ...common,
  ...category,
  ...record,
  ...coupon,
  ...comment,
  ...vip,
  ...award,
  get(url, params) {
    return fetch.get(url, params)
  },
  post(url, params) {
    return fetch.post(url, params)
  },
  json(url, params) {
    return fetch.json(url, params)
  },
  upLoad(url, params) {
    return fetch.upLoad(url, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js